<template>
  <div class="kit-page container">
    <bread-crumbs :items="breadCrumbs" />
    <div class="kit-page__cart-content mobile-only">
      <h4>{{ $t('kits.choose') }}</h4>
      <div class="kit-page__cart-listing">
        <div
          v-for="kitItem in kit.kit_items"
          :key="kitItem.code"
          :class="[
            'kit-page__cart-item',
            {
              'kit-page__cart-item--selected': kitItem.code === currentKit.code,
            },
          ]"
          @click="setCurrentKit(kitItem)"
        >
          <div class="kit-page__cart-item-image">
            <transition name="fade">
              <img
                v-if="selectedKit(kitItem.code)"
                :src="selectedKit(kitItem.code).image"
                class="kit-page__cart-item-image-selected"
              />
              <skinny-cross
                v-else-if="kitItem.code !== currentKit.code"
                class="kit-page__cart-item-image-not-selected"
                color="#323236"
              />
            </transition>
          </div>
          <p
            :class="[
              'kit-page__cart-item-name',
              {
                'kit-page__cart-item-name--selected':
                  kitItem.code === currentKit.code,
              },
            ]"
          >
            {{ kitItem.name || kitItem.code }}
          </p>
        </div>
      </div>
    </div>
    <div class="kit-page__kit-content">
      <div class="kit-page__products">
        <div class="kit__search">
          <IconSearch />
          <input
            ref="input"
            v-model="searchQuery"
            type="search"
            name="q"
            autocomplete="off"
            autocapitalize="off"
            class="kit-search__input"
            :placeholder="$t('header.search_placeholder')"
            @input="searchByQuery"
          />
        </div>
        <section class="kit-page__filters">
          <div v-if="availableTaxons.length" class="kit__section-title">
            <h4>
              {{ $t('available_taxons') }}
            </h4>
          </div>
          <div class="kit__taxons-container">
            <div
              :class="[
                'kit__taxons',
                {
                  'kit__taxons--mobile': $device.isMobile,
                },
              ]"
            >
              <button
                v-for="taxon in availableTaxons"
                :key="taxon.id"
                :class="[
                  'kit__taxons-item',
                  {
                    'kit__taxons-item--active':
                      selectedTaxon && selectedTaxon.id === taxon.id,
                  },
                ]"
                @click="selectTaxon(taxon)"
              >
                {{ taxon.name }}
              </button>
            </div>
          </div>
          <div v-if="availableTaxons.length" class="kit__nav">
            <button
              :class="[
                'kit__nav-item',
                'kit__nav-item--left',
                {
                  'kit__nav-item--hide':
                    !translateX || translateX === 0 || $device.isMobile,
                },
              ]"
              @click="navGallery(1)"
            >
              <ArrowLeft class="kit__arrow" />
            </button>
            <button
              :class="[
                'kit__nav-item',
                'kit__nav-item--right',
                {
                  'kit__nav-item--hide': $device.isMobile,
                },
              ]"
              @click="navGallery(-1)"
            >
              <ArrowRight class="kit__arrow" />
            </button>
          </div>
          <div v-if="selectedTaxon" class="kit__section-title">
            <h4>
              {{ $t('selected_taxon') }}
            </h4>
          </div>
          <div v-if="selectedTaxon" class="kit__tags">
            <button class="kit__tags-item">
              {{ selectedTaxon.name }}
              <span class="kit__tags-item-remove" @click="removeTaxon()">
                <cross-icon />
              </span>
            </button>
          </div>
        </section>
        <transition name="fade">
          <div v-if="showProducts" class="kit-page__products-listing">
            <product
              v-for="p in products"
              :key="p.id"
              :product="p"
              :send-gtm-data="true"
              :capture-click="true"
              @click="selectProduct(p)"
            />
          </div>
        </transition>
        <div v-show="!showProducts" class="kit-page__modal-content-loading">
          <logo-loading />
        </div>
        <div v-show="showProducts && products.length < 1">
          <p>{{ $t('search.empty.no_products_found') }}</p>
        </div>
        <modal
          class="kit-page__modal-modal"
          :open="isModalOpen"
          @close="toogleModal('close')"
        >
          <template v-slot:title>
            {{ $t('edit_product') }}
          </template>
          <div class="kit-page__modal-content">
            <div class="kit-page__modal-content-loading">
              <logo-loading v-show="modalIsLoadingProduct" />
            </div>

            <product-editor
              v-if="!modalIsLoadingProduct && product && productStock"
              :product="product"
              :product-stock="productStock"
              :gallery-items="galleryItems"
              :item-editor="true"
              :current-item-code="currentKit.code"
              :permitted-case-type-ids="currentKit.case_type_ids"
              @updateItemProduct="updateItemProduct"
            />
          </div>
        </modal>
      </div>
      <div class="kit-page__cart desktop-only">
        <div class="kit-page__cart-header">
          <h2>{{ $t('kits.yours') }}</h2>
          <div class="kit-page__cart-pricing">
            <b v-if="kit.old_price" class="kit-page__cart-old-price">{{
              formatPrice(kit.old_price)
            }}</b>
            <b class="kit-page__cart-price">{{ formatPrice(kit.price) }}</b>
          </div>
        </div>
        <div class="kit-page__cart-content">
          <h4>{{ $t('kits.choose') }}</h4>
          <div class="kit-page__cart-listing">
            <div
              v-for="kitItem in kit.kit_items"
              :key="kitItem.code"
              :class="[
                'kit-page__cart-item',
                {
                  'kit-page__cart-item--selected':
                    kitItem.code === currentKit.code,
                },
              ]"
              @click="setCurrentKit(kitItem)"
            >
              <div class="kit-page__cart-item-image">
                <transition name="fade">
                  <img
                    v-if="kitItems.find((ki) => ki.code === kitItem.code)"
                    :src="kitItems.find((ki) => ki.code === kitItem.code).image"
                    class="kit-page__cart-item-image-selected"
                  />
                  <skinny-cross
                    v-else-if="kitItem.code !== currentKit.code"
                    class="kit-page__cart-item-image-not-selected"
                    color="#323236"
                  />
                </transition>
              </div>
              <p
                :class="[
                  'kit-page__cart-item-name',
                  {
                    'kit-page__cart-item-name--selected':
                      kitItem.code === currentKit.code,
                  },
                ]"
              >
                {{ kitItem.name || kitItem.code }}
              </p>
            </div>
          </div>
        </div>

        <v-button
          type="submit"
          :loading="addingNewItem"
          :label="$t('product_form.add_to_cart')"
          class="kit-page__add-to-cart"
          @click.prevent="addToCart"
        />
      </div>
    </div>

    <div class="kit-page__mobile-footer mobile-only">
      <div class="kit-page__cart-pricing">
        <b v-if="kit.old_price" class="kit-page__cart-old-price">{{
          formatPrice(kit.old_price)
        }}</b>
        <b class="kit-page__cart-price">{{ formatPrice(kit.price) }}</b>
      </div>
      <v-button
        type="submit"
        :loading="addingNewItem"
        :label="$t('product_form.add_to_cart')"
        class="kit-page__add-to-cart"
        @click.prevent="addToCart"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BreadCrumbs from '~/components/BreadCrumbs.vue'
import VButton from '~/components/v-button/VButton.vue'
import Product from '~/components/product/Product.vue'
import ProductEditor from '~/components/product/product-editor/ProductEditor.vue'
import Modal from '~/components/Modal.vue'
import LogoLoading from '~/components/loadings/logo'
import SkinnyCross from '~/components/icons/skinny-cross/SkinnyCross.vue'
import ArrowLeft from '~/components/icons/arrow-left/ArrowLeft'
import ArrowRight from '~/components/icons/arrow-right/ArrowRight'
import CrossIcon from '~/components/icons/cross/Cross.vue'
import IconSearch from '~/components/icons/magnifier/Magnifier'

import appendUrlParam from '~/utils/appendUrlParam'
import toQueryString from '~/utils/toQueryString.js'

import priceable from '~/mixins/priceable'
import fixedBlock from '~/mixins/fixed-block'
import scrollingNavigator from '~/mixins/scrolling-navigator'

export default {
  components: {
    BreadCrumbs,
    SkinnyCross,
    VButton,
    Product,
    ProductEditor,
    Modal,
    LogoLoading,
    ArrowLeft,
    ArrowRight,
    CrossIcon,
    IconSearch,
  },
  mixins: [priceable, fixedBlock, scrollingNavigator],
  async asyncData({ $axios, store, params: { kit: kitPermalink }, error }) {
    try {
      const storeInfo = store.getters.storeInfo
      const params = {
        ...storeInfo,
      }

      const { kit } = await $axios.$get('/kits/' + kitPermalink, {
        params,
      })

      return {
        kit,
        // eslint-disable-next-line camelcase
        currentKit: kit?.kit_items[0],
        // eslint-disable-next-line camelcase
        availableTaxons: kit?.kit_items[0]?.taxons,
        selectedTaxon: null,
        searchQuery: null,
      }
    } catch (err) {
      error({
        statusCode: 404,
        message: 'Something went wrong',
      })
    }
  },
  data() {
    return {
      kit: null,
      currentKit: null,
      addingNewItem: false,
      showProducts: true,
      isModalOpen: false,
      modalIsLoadingProduct: true,
      product: null,
      kitItems: [],
      productStock: null,
      timer: null,
    }
  },
  computed: {
    ...mapGetters({ galleryItems: 'product/galleryItems' }),
    products() {
      return this.normalizeProducts(this.currentKit.products)
    },
    breadCrumbs() {
      return [
        { name: 'Kits', permalink: 'kits' },
        {
          name: this.kit.name,
          permalink: 'kits/' + this.kit.permalink,
        },
      ]
    },
    listClassName() {
      return 'kit__taxons'
    },
  },
  mounted() {
    if (this.$device.isDesktop)
      this.startFixedBlock('.kit-page__kit-content', '.kit-page__cart')
  },
  methods: {
    searchByQuery() {
      clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.fetchProducts()
      }, 1000)
    },
    selectedKit(kitItemCode) {
      return this.kitItems.find((ki) => ki.code === kitItemCode)
    },
    async addToCart() {
      try {
        if (this.kitItems.length < this.kit.kit_items.length) {
          this.$displayTopMessage(this.$t('kits.need_complete'), {
            type: 'error',
          })
          return
        }

        this.addingNewItem = true

        const params = {
          ...this.$store.getters.storeInfo,
        }

        this.kitItems.forEach((ki) => delete ki.image)

        await this.$apiv2.$post(appendUrlParam('/kits/populate', params), {
          kit_id: this.kit.id,
          kit_items: this.kitItems,
        })

        this.$router.push('/cart')
      } catch (err) {
        this.$sentry.captureException(err.response || err)
      } finally {
        this.addingNewItem = false
      }
    },
    updateItemProduct(kitProduct) {
      this.kitItems = this.kitItems.filter(
        (ki) => ki.code !== this.currentKit.code
      )

      this.kitItems.push({
        ...kitProduct,
        code: this.currentKit.code,
        product_id: this.product.id,
        image: this.product.images[0].url,
      })

      const kitWithoutProduct = this.kit.kit_items.filter(
        (ki) => !this.kitItems.map((kt) => kt.code).includes(ki.code)
      )

      if (kitWithoutProduct[0]) this.setCurrentKit(kitWithoutProduct[0])

      this.toogleModal('close')
    },
    toogleModal(status) {
      if (status === 'open') {
        this.isModalOpen = true
      } else {
        this.isModalOpen = false
      }
    },
    async selectProduct(prod) {
      this.toogleModal('open')
      this.modalIsLoadingProduct = true

      try {
        const { query } = this.$route
        const { product, productStock } = await this.$store.dispatch(
          'product/fetchProduct',
          {
            slug: prod.slug,
            query,
          }
        )

        this.product = product
        this.productStock = productStock
      } catch (err) {
        this.$sentry.captureException(err.response || err)
      } finally {
        this.modalIsLoadingProduct = false
      }
    },
    selectTaxon(taxon) {
      if (this.selectedTaxon?.id !== taxon.id) {
        this.selectedTaxon = taxon
      } else {
        this.selectedTaxon = null
      }

      this.fetchProducts()
    },
    removeTaxon() {
      this.selectedTaxon = null
      this.fetchProducts()
    },
    async setCurrentKit(kitItem) {
      this.showProducts = false

      if (kitItem) {
        const response = await this.$axios.$get(
          `/kit_items/${kitItem.id}/products?${toQueryString(
            this.$store.getters.storeInfo
          )}`
        )
        kitItem.products = response.products
        this.availableTaxons = response.taxons
      }
      this.currentKit = kitItem
      this.searchQuery = null
      this.selectedTaxon = null

      setTimeout(() => {
        this.showProducts = true
      }, 500)
    },
    async fetchProducts() {
      this.showProducts = false

      const params = {
        ...this.$store.getters.storeInfo,
      }
      if (this.selectedTaxon?.id) params.taxon_id = this.selectedTaxon?.id
      if (this.searchQuery) params.search_query = this.searchQuery

      const response = await this.$axios.$get(
        `/kit_items/${this.currentKit?.id}/products?${toQueryString(params)}`
      )

      this.currentKit.products = response.products
      this.availableTaxons = response.taxons
      this.updateSelectorScroll(0)

      setTimeout(() => {
        this.showProducts = true
      }, 500)
    },
    normalizeProducts(products) {
      const normalizedProducts = products.map((p) => ({
        ...p,
        name: p.name || p.names,
        in_stock: true,
        image_info: { url: p.image },
      }))

      return normalizedProducts
    },
  },
  head() {
    return {
      title: this.kit?.name,
    }
  },
}
</script>

<style lang="scss">
@import '~/assets/css/container.scss';
@import '~/assets/css/btn.scss';
@import '~/assets/css/_section.scss';
@import '~/assets/css/stamped.scss';
@import '~/assets/css/_content.scss';

.kit-page__modal-content {
  height: 100%;
  width: 100%;
}

.kit-page__modal-content-loading {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
}

.kit-page {
  margin-bottom: 50px;
  position: relative;

  .kit-page__kit-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    // grid-gap: 3 * $v4_gutter;
    margin-top: 50px;
    width: 100%;
    min-height: 100vh;
    height: 100%;

    @media (min-width: $v4_desktop) {
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    }

    .kit-page__products-listing {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 3 * $v4_gutter;

      @media (min-width: $v4_desktop) {
        grid-gap: 8 * $v4_gutter;
        grid-template-columns: 1fr 1fr 1fr;
      }
    }

    .kit-page__cart {
      $cart-border-radius: 20px;
      width: 400px;
      min-height: 500px;
      border-radius: $cart-border-radius;
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
      height: 100%;
      height: 500px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      // margin-left: 40px;
      min-width: 400px;
      justify-self: flex-end;

      @media (max-width: $v4_desktop) {
        margin-left: 0px;
      }

      .kit-page__cart-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f5fbfb;
        padding: 30px 50px;
        border-radius: $cart-border-radius;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;

        h2 {
          font-size: 20px;
        }
      }
    }
  }

  .kit-page__add-to-cart {
    position: absolute;
    margin: 0 auto;
    margin-top: 30px;
    bottom: 30px;
  }

  .kit-page__cart-pricing {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .kit-page__cart-price {
      font-size: 20px;
      color: $v4_color_primary;
    }

    .kit-page__cart-old-price {
      position: relative;
    }

    .kit-page__cart-old-price:before {
      position: absolute;
      content: '';
      left: 0;
      top: 50%;
      right: 0;
      border-top: 1px solid;
      border-color: inherit;

      -webkit-transform: rotate(-5deg);
      -moz-transform: rotate(-5deg);
      -ms-transform: rotate(-5deg);
      -o-transform: rotate(-5deg);
      transform: rotate(-5deg);
    }
  }

  .kit-page__mobile-footer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    background: white;
    padding: 20px 10px;
    border-radius: 5px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
  }

  .kit-page__mobile-footer .kit-page__add-to-cart {
    position: static;
    margin: 0;
    bottom: 0;
  }

  .kit-page__cart-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 10px;

    @media (max-width: $v4_desktop) {
      margin-top: 50px;
      position: fixed;
      left: 0;
      top: 0;
      background: white;
      z-index: 100;
      box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
    }

    h4 {
      margin-bottom: 20px;
    }

    .kit-page__cart-listing {
      display: flex;
      justify-content: space-evenly;
      width: 100%;

      @media (max-width: $v4_desktop) {
        display: block;
        justify-content: none;
        text-align: center;

        overflow: auto;
        white-space: nowrap;

        &::-webkit-scrollbar {
          display: none;
        }

        & {
          -ms-overflow-style: none;
        }

        overflow: -moz-scrollbars-none;
      }

      .kit-page__cart-item-name--selected {
        font-weight: bold;
      }

      .kit-page__cart-item {
        text-align: center;
        cursor: pointer;

        @media (max-width: $v4_desktop) {
          display: inline-block;
          margin: 0px 10px;
          padding-top: 10px;
        }

        .kit-page__cart-item-name {
          margin-top: 10px;

          @media (max-width: $v4_desktop) {
            margin-bottom: 5px;
          }
        }

        .kit-page__cart-item-image {
          width: 100px;
          height: 100px;
          box-shadow: 0px 0px 2px 1px rgba(0, 0, 0, 0.2);
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;

          @media (max-width: $v4_desktop) {
            width: 70px;
            height: 70px;
            margin-top: -5px;
          }

          img {
            width: 100%;
            object-fit: cover;
            border-radius: 5px;
          }

          .kit-page__cart-item-image-not-selected {
            transform: rotate(45deg);
            width: 50%;
            height: 50%;
            fill: $v4_color_text;
            margin-top: 10px;
          }
        }

        &--selected {
          .kit-page__cart-item-image {
            box-shadow: 0px 0px 3px 2px rgba($v4_color_primary, 0.2);
          }
        }
      }
    }
  }

  .kit__section-title {
    margin-top: 20px;
    margin-bottom: 10px;

    h4 {
      font-weight: 500;
      font-size: 15px;
    }
  }

  .kit__taxons-container {
    overflow: hidden;
    margin-left: -15px;
    padding-left: 15px;
    margin-right: -15px;
    padding-right: 15px;
  }

  .kit__taxons {
    overflow: visible;
    white-space: nowrap;
    transition: transform 400ms cubic-bezier(0.165, 0.84, 0.44, 1) 0s;
    margin-left: -15px;
    padding-left: 15px;
    margin-right: -15px;
    padding-right: 15px;

    &--mobile {
      overflow: auto;
    }

    &-item {
      display: inline-block;
      margin-right: 10px;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    & {
      -ms-overflow-style: none;
    }

    overflow: -moz-scrollbars-none;
  }

  .kit__taxons-item {
    white-space: nowrap;
    background: none;
    font-weight: bold;
    border-radius: 3px;
    border: 1px solid $v4_color_primary;
    padding: 5px 10px;
    height: 35px;
    cursor: pointer;
    font-size: 15px;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;

    &:hover {
      background: $v4_color_primary_light;
    }

    &--active {
      background: $v4_color_primary_light;

      &:hover {
        background: $v4_color_primary_light;
      }
    }
  }

  .kit__nav {
    display: flex;
    justify-content: space-between;

    .kit__arrow {
      width: 25px;
      fill: $v4_color_blue;
      transition: all 0.2s ease-in-out;
    }

    .kit__nav-item {
      margin-top: -37px;
      width: 40px;
      height: 40px;
      line-height: 78px;
      z-index: 5;
      text-align: center;
      border-radius: 50%;
      border: 0;
      background-color: rgba(229, 235, 235, 0.5);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &--left {
        margin-left: -15px;
      }

      &--right {
        margin-right: -15px;
      }

      &:focus {
        outline: 0;
      }
      &:hover {
        background-color: rgba(229, 235, 235, 1);
      }

      &--hide {
        opacity: 0;
      }
    }
  }

  .kit__tags {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0px;
  }

  .kit__tags-item {
    border-radius: 25px;
    padding: 5px 10px;
    background: $v4_color_primary_light;
    border: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;

    &-remove {
      margin-left: 10px;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      padding: 3px;
      cursor: pointer;
    }

    svg {
      width: 10px;
    }
  }

  .kit__search {
    margin: 20px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;

    @media (max-width: $v4_desktop) {
      margin-top: 100px;
    }
  }

  .kit__search svg {
    position: absolute;
    width: 25px;
    height: 25px;
    top: 10px;
    left: 10px;
    fill: #afafaf;
  }

  .kit-search__input {
    border: 0;
    background-color: transparent;
    width: 100%;
    height: 40px;
    padding: 0;
    font-size: 18px;
    border: 0;
    background: rgba(0, 0, 0, 0.05);
    padding: 10px;
    border-radius: 3px;
    padding-left: 40px;

    &::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }

    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;

    &::-webkit-input-placeholder {
      color: darken($color_line, 20%);
    }

    &:focus {
      border: 0;
      outline: 0;
      box-shadow: none;
    }
  }
}
</style>
